import React, { useEffect, useState } from "react";
import { Multiselect } from "multiselect-react-dropdown";

function CustomMultiSelect({ styles, id, options, showCheckbox, onSelect, onSearch, onRemove, displayValue, placeholder, closeIcon, selectedValues }) {
	return (
        <div style={{ position: 'relative'}}>
            <i className="zmdi zmdi-caret-down" style={{ position: 'absolute', right: '15px', top: '5px', fontSize: '25px' }}></i>
        <Multiselect styles={styles} id={id} options={options} showCheckbox={showCheckbox} onSelect={onSelect} onSearch={onSearch} onRemove={onRemove} displayValue={displayValue} placeholder={placeholder} closeIcon={closeIcon} selectedValues={selectedValues} />
        </div>
    )
}

export default CustomMultiSelect;